//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'my-addrpicker',
    props: ['status', 'list'],
    data () {
        return {
            popupVisible: false,
            areaShow: false,
            areaValue: [],
            addrList: [],
            isShowAdd: false,
            addrinfo: {},
            statusOption: [
                {
                    label: '是',
                    value: '1',
                    disabled: false
                },
                {
                    label: '否',
                    value: '0',
                    disabled: false
                }
            ],
            params: {
                id: '',
                contactname: '',
                mobile: '',
                privince: '',
                privinceName: '',
                city: '',
                cityName: '',
                area: '',
                areaName: '',
                address: '',
                zip: '',
                addstatus: '1',
                addrarea: ''
            }
        }
    },
    methods: {
        close () {
            this.$emit('close', false)
        },
        add () {
            this.isShowAdd = true
            this.addrinfo = JSON.parse(JSON.stringify(this.params))
        },
        editAddr (v) {
            this.isShowAdd = true
            this.addrinfo = JSON.parse(JSON.stringify(v))
            this.addrinfo.addrarea = v.privinceName + ' ' + v.cityName + ' ' + v.areaName
        },
        selAddr (v) {
            this.$emit('selValue', v)
        },
        save () {
            if (this.addrinfo.contactname === '') {
                this.Toast('请输入收礼人姓名')
            } else if (this.addrinfo.mobile === '' || ((this.addrinfo.mobile).trim()).length !== 11) {
                this.Toast('请输入完善手机号')
            } else if (this.addrinfo.privince === '') {
                this.Toast('请选择所在地区')
            } else if (this.addrinfo.address === '') {
                this.Toast('请输入详细地址')
            } else if (this.addrinfo.zip === '') {
                this.Toast('请输入邮编')
            } else {
                // var formdata = new FormData()
                // formdata.append('id', this.addrinfo.id)
                // formdata.append('contactname', this.addrinfo.contactname)
                // formdata.append('mobile', this.addrinfo.mobile)
                // formdata.append('privince', this.addrinfo.privince)
                // formdata.append('city', this.addrinfo.city)
                // formdata.append('area', this.addrinfo.area)
                // formdata.append('address', this.addrinfo.address)
                // formdata.append('zip', this.addrinfo.zip)
                // formdata.append('addstatus', this.addrinfo.addstatus)
                var _data = {
                    'id': this.addrinfo.id,
                    'contactname': this.addrinfo.contactname,
                    'mobile': this.addrinfo.mobile,
                    'privince': this.addrinfo.privince,
                    'city': this.addrinfo.city,
                    'area': this.addrinfo.area,
                    'address': this.addrinfo.address,
                    'zip': this.addrinfo.zip,
                    'addstatus': this.addrinfo.addstatus
                }
                this.$http.post('/userAddressinfo/userAddressinfoSaveOrUpdate', _data).then(res => {
                    this.isShowAdd = false
                    if (res.data.status === 1 && res.data.code === 200) {
                        this.showData()
                    } else {
                        this.Toast('保存失败，请检查数据')
                    }
                })
            }
        },
        showData () {
            this.$http.get('/userAddressinfo/address', {}).then(res => {
                if (res.data.status === 1 && res.data.code === 200) {
                    this.addrList = res.data.data
                }
            })
        },
        showDDL () {
            this.areaShow = true
        },
        checkArea (v) {
            console.log(v)
            this.areaShow = false
            this.addrinfo.privince = v[0].id
            this.addrinfo.privinceName = v[0].name
            this.addrinfo.city = v[1].id
            this.addrinfo.cityName = v[1].name
            this.addrinfo.area = v[2].id
            this.addrinfo.areaName = v[2].name
            this.addrinfo.addrarea = v[0].name + ' ' + v[1].name + ' ' + v[2].name
            this.addrinfo.zip = v[2].yzcode
        }
    },
    created () {
        if (this.list && this.list.length > 0) {
            this.addrList = this.list
        }
    },
    watch: {
        status (v) {
            this.popupVisible = v
        },
        list (v) {
            this.addrList = v
        }
    }
}
